<template>
  <Layout>
    <div class="row page-title align-items-center">
      <div class="col-sm-4 col-xl-6">
        <h4 class="mb-1 mt-0">Cargas Masivas de Informes Antiguos</h4>
      </div>
    </div>
    <b-card header="Acciones rápidas" header-tag="header">
      <b-button-group size="md">
        <b-button v-b-modal.new-mass-upload variant="primary">Nueva Carga Masiva</b-button>
      </b-button-group>


    </b-card>
    <b-row>
      <b-col>
        <MassUploads table-id='pending-uploads' title="Cargas Masivas en trabajo" status='pending_job'
          title-variant='warning' filters show-admin-status>
        </MassUploads>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <MassUploads table-id='processed-uploads' title="Cargas Masivas procesadas" status='processed'
          title-variant='success' filters show-admin-status>
        </MassUploads>
      </b-col>
    </b-row>
    <b-modal id="new-mass-upload" title="Nueva Carga" hide-footer>
      <new-mass-upload-form @submit="updateTables" @cancel="$bvModal.hide('new-mass-upload')">
      </new-mass-upload-form>
    </b-modal>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import MassUploads from '@components/old_reports/widget-mass-uploads'
import NewMassUploadForm from "@components/old_reports/new_mass_upload_form.vue"

export default {
  page: {
    title: 'Carga Masiva',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    MassUploads,
    NewMassUploadForm
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    updateTables() {
      this.$root.$emit('bv::refresh::table', 'pending-uploads')
      this.$root.$emit('bv::refresh::table', 'invalid-uploads')
      this.$root.$emit('bv::refresh::table', 'validated-uploads')
      this.$root.$emit('bv::refresh::table', 'processed-uploads')
    },
  },
}
</script>

<style>

</style>

